import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {onyxLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
  },
  textStyle: {
    color: onyxLight,
    marginRight: indent * 1.3,
  },
});
